import React from 'react'
import PropTypes from 'prop-types'
import { Icon, ChevronRightIcon } from 'src/components/icons'
import { Columns } from 'src/components/layout'
import { getColor } from 'src/styles'
import NavLink from '../NavLink'
import styles from './PrimaryNavLink.scss'

const PrimaryNavLink = ({ icon, children, color, ...props }) => (
  <Columns as={NavLink} align="center" className={styles.link} style={{ color: getColor(color) }} {...props}>
    <Icon icon={icon} className={styles.icon} />
    <span className={styles.label}>
      {children}
      <span className={styles.background} style={{ background: getColor(color) }} />
    </span>
    <Icon size="xs" icon={ChevronRightIcon} />
  </Columns>
)

PrimaryNavLink.propTypes = {
  ...NavLink.props,
  icon: PropTypes.elementType,
  color: PropTypes.string,
}

PrimaryNavLink.defaultProps = {
  color: 'primary',
}

export default PrimaryNavLink
